/**
 * Returns the current URL without any hash params, preserving query params
 */
export function getUrlWithoutHashParams() {
    return window.location.href.split('#')[0];
}
//# sourceMappingURL=url_without_hash_params.js.map